import { observable, action, runInAction, computed } from 'mobx'
import { message } from 'antd'
import { json, get } from '../../../../utils/ajax'
import { isAuthenticated } from '../../../../utils/Session'
import uuid from 'uuid/v4'

class SpecialToolListStore {

    @observable list
    @observable pagination
    @observable loading
    @observable listForm
    @observable modalList
    @observable annexId
    @observable modalListContent
    @observable contents
    @observable searchForms

    constructor () {
        this.list = []
        this.pagination = {}
        this.loading = false
        this.listForm = {}
        this.modalList = 'hide'
        this.annexId = ''
        this.modalListContent = 'hide'
        this.contents = []
        this.searchForms = {}
    }

    /**
     * 初始化页面
     */
    @action
    initListPage = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        if (page) {
            page--
        } else if (this.pagination.page) {
            page = this.pagination.page - 1
        } else {
            page = 0
        }
        // 构建查询参数
        let search= {}
        Object.keys(this.searchForms).forEach(key => {
            search[`search.${key}`] = this.searchForms[key] ? this.searchForms[key] : ''
        })
        search.page = page
        search.size = 10
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/list`,search)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.list = res.content
            this.pagination = {
                results: res.size,
                page: res.number + 1,
                total: res.totalElements
            }
            this.loading = false
        })
    }

    /**
     * 显示清单列表编辑框
     */
    @action
    showList = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modalList = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 清空清单列表form
     */
    @action
    empetyForms = () => {
        runInAction(() => {
            this.listForm = {}
        })
    }

    /**
     * 图片上传
     */
    @action
    imageUpload = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 工具清单平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            id: {value: this.listForm.id},
            number: {value: this.listForm.number},
            numbering: {value: this.listForm.numbering},
            name: {value: this.listForm.name},
            use: {value: this.listForm.use},
            image: {value: this.listForm.image},
        }
        return fields
    }
    /**
     * 将表单对象化，绑值给store。form
     */
    @action
    onEditFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let listForm = {
            id: fields.id.value,
            number: fields.number.value,
            numbering: fields.numbering.value,
            name: fields.name.value,
            use: fields.use.value,
            image: fields.image.value,
        }
        this.listForm = listForm
    }

    /**
     * 新增工具清单 + 修改工具清单
     */
    @action
    saveList = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.listForm.id) {
            let arrs = this.list.map(item => {
                return item.number
            })
            let arr1 = this.listForm.number
            for(let i = 0;i < arrs.length;i++){
                if(arrs[i] === arr1){
                    return message.warning('该专用工具号已存在，请查对后在添加!')
                }
            }
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/add`, {
                ...this.listForm
            })
            runInAction(() => {
                this.modalList = 'hide'
                this.loading = false
            })
            this.initListPage(this.page)
        } else {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/update`, {
                ...this.listForm
            })
            runInAction(() => {
                this.modalList = 'hide'
                this.loading = false
            })
            this.initListPage(this.page)
        }
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action
    initEdit = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/id/${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.listForm = res
            this.loading = false
            this.modalList = 'show'
        })
    }

    /**
     * 删除
     */
    @action
    deleteList = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
        })
        if(this.list.length === 1){
            await this.initListPage(this.pagination.page -1)
        }else{
            await this.initListPage(this.pagination.page)
        }
    }

    /**
     * 保存上传附件ID
     */
    addAnnex = (id) => {
        runInAction(() => {
            this.annexId = id
        })
    }

    /**
     * 上传附件
     */
    @action
    annexUpload = async (info) => {
        runInAction(() => {
            this.loading = false
        })
        if (info.file.status === 'done') {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/list/update`, {
                id: this.annexId,
                annexName : info.file.name,
                url : info.file.response
            })
            message.success(`${info.file.name} 上传成功`)
            await this.initListPage(this.page)
            return
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 显示清单内容编辑框
     */
    @action
    showListContent = (flag) => {
        runInAction(() => {
            this.loading = true
            this.modalListContent = flag ? 'show' : 'hide'
            this.loading = false
        })
    }

    /**
     * 获取到每个编辑器的内容和ID
     */
    @action
    setContent = (id, value) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, content: value}
                }
                return item
            })
        })
    }

    /**
     * 删除编辑框里的图片
     */
    @action
    delImage = (contentId, imageIndex) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === contentId) {
                    return {...item, image: item.image.trim().split(',').filter((img, index) => index !== imageIndex).join(',')}
                }
                return item
            })
        })
    }

    /**
     * 获取到右图左文的内容和ID
     */
    @action
    addContent = (id, type) => {
        const contents = []
        this.contents.forEach(item => {
            contents.push(item)
            if (item.id === id) {
                contents.push({
                    id: `${uuid()}`,
                    image: '',
                    content: '',
                    type: type * 1,
                    listId: this.listId
                })
            }
        })
        runInAction(() => {
            this.contents = contents
        })
    }

    /**
     * 删除编辑框里的内容
     */
    @action
    delContent = (id) => {
        const contents = this.contents.filter(item => item.id !== id)
        runInAction(() => {
            this.contents = contents.length > 0 ? contents : [{
                    id: `${uuid()}`,
                    image: '',
                    content: '',
                    type: 1,
                    listId: this.listId
                }]
        })
    }

    /**
     * 添加图片
     */
    @action
    addImage = (id, url) => {
        runInAction(() => {
            this.contents = this.contents.map(item => {
                if (item.id === id) {
                    return {...item, image: item.image.trim().length > 0 ? `${item.image},${url}` : url}
                }
                return item
            })
        })
    }

    /**
     * 获取ID 用于上移编辑框
     */
    @action
    contentUp = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if (index > 0) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index - 1)
            })
        }
    }

    /**
     * 获取ID 用于下移编辑框
     */
    @action
    contentDown = (id) => {
        const index = this.contents.findIndex(item => item.id === id)
        if(index+1 === this.contents.length){
            return
        }
        if (index >= 0 && index < this.contents.length) {
            runInAction(() => {
                this.contents = this.swapItems(this.contents, index, index + 1)
            })
        }
    }

    swapItems = (arr, index1, index2) => {
        arr[index1] = arr.splice(index2, 1, arr[index1])[0]
        return arr
    }

    /**
     * 初始化系统目录表单，可以不传参数，初始化全部为 null
     * @param id 根据id查询
     */
    @action
    initCatalog = async (id) => {
        runInAction(() => {
            this.contents = []
            this.loading = true
        })
        const contents = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/listContent/searchOne?listId=${id}`)
        runInAction(() => {
            this.listId = id
            this.contents = contents.length ? contents : [{
                    id: `${uuid()}`,
                    image: '',
                    content: '',
                    type: 1,
                    listId: id
                }]
            this.loading = false
        })
        await this.showListContent(true)
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }

    /**
     * 新增内容
     */
    @action
    saveContent = async () => {
        runInAction(() => {
            this.loading = true
        })
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/listContent/add`,this.contents)
        runInAction(() => {
            this.loading = false
        })
        await this.showListContent(false)
    }

    /**
     * 多条件查询
     * 平行化表单，传值给form
     */
    @computed
    get formFields() {
        let formFields = {
            name: {value: this.searchForms.name},
            number: {value: this.searchForms.number},
        }
        return formFields
    }

    /**
     * 多条件查询
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormChange = (changedFields) => {
        const fields = {...this.formFields, ...changedFields}
        let searchForms = {
            name: fields.name.value,
            number: fields.number.value,
        }
        this.searchForms = searchForms
    }

    /**
     * 重置
     */
    @action
    fieldsReset(){
        runInAction(() => {
            this.loading = true
            this.searchForms = {}
            this.initListPage(this.page)
            this.loading = false
        })
    }
}
export default new SpecialToolListStore()


// WEBPACK FOOTER //
// ./src/Backend/dongfeng/specialTool/SpecialToolList/store.js